import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const showHomeButton = location.pathname === "/spyfall" ||
  (location.pathname !== "/" && !location.pathname.startsWith("/spyfall/game") && !location.pathname.startsWith("/promptquestions/game"));

  return (
    <header style={styles.header}>
      {/* Left placeholder to balance the flex */}
      <div style={styles.placeholder} />

      {/* Centered title */}
      <h1 style={styles.title} onClick={() => navigate("/")}>
        Social Deduction
      </h1>

      {/* Home button on right */}
      {showHomeButton ? (
        <button style={styles.homeButton} onClick={() => navigate("/")}>
          Home ←
        </button>
      ) : (
        <div style={styles.placeholder} />
      )}
    </header>
  );
}

const styles = {
  header: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2rem 1rem",
    borderBottom: "1px solid #ddd",
    fontFamily: "sans-serif",
  },
  title: {
    margin: 0,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "4rem",
    cursor: "pointer",
  },
  homeButton: {
    zIndex: 1,
    padding: "0.4rem 0.8rem",
    fontSize: "0.9rem",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#4e6cff",
    color: "#fff",
    cursor: "pointer",
  },
  placeholder: {
    width: "72px",  // match approx width of homeButton to keep title centered
  },
};
